var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip && _vm.tooltip.length > 0 ? _vm.tooltip : 'EMPTY',
    classes: 'badge-theme text-pre',
  }),expression:"{\n    content: tooltip && tooltip.length > 0 ? tooltip : 'EMPTY',\n    classes: 'badge-theme text-pre',\n  }"}],class:_vm.badgeClass},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }